/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import CloseIcon from "@mui/icons-material/Close";
import {
    Autocomplete,
    Box,
    Button,
    ButtonGroup,
    Chip,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useForm } from "src/shared/hooks/useForm";
import { selectMainState, useSelector } from "src/stateManagement/redux";
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from "sweetalert2";
import { StatusConditions, TypesOfActivities } from "src/stateManagement/redux/slices/shared/interfaces";
import EditIcon from '@mui/icons-material/Edit';
import { capitalizeWords } from "src/shared/util/textFunctions";

interface Props {
    TabDisable: boolean;
    open: boolean;
    setOpen: any;
    requirements: any[];
    setRequeriments: any;
}

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

export const Requirements = ({
    TabDisable,
    setOpen,
    open,
    requirements,
    setRequeriments,
}: Props) => {
    const { locationName, lastStatusConditions, requirements: currentRequirements } = useSelector((state: any) => state.location);

    const { configModules } = useSelector(selectMainState);

    const [typesActivities, setTypesActivities] = useState<TypesOfActivities[]>([])

    const [statusConditions, setStatusConditions] = useState<StatusConditions[]>([])

    const [optimizationActivitiesStates, setOptimizationActivitiesStates] = useState<any[]>([])

    const [enableOptions, setEnableOptions] = useState<string[]>([])

    const [reasonsOfPriority, setReasonsOfPriority] = useState<string[]>([])

    const [formValues, handleInputChange, reset, setNuewValues] = useForm({
        type: "",
        comment: "",
        status: "pending",
        priority: "normal",
        priorityReason: "",
        priorityExtraReason: ""
    });

    const [listActiveBloquers, setlistActiveBloquers] = useState<any>([])

    useEffect(() => {
        if (Array.isArray(configModules?.typesActivitiesForRequirements)) {
            setTypesActivities(configModules?.typesActivitiesForRequirements)
        }
        if (Array.isArray(configModules?.statusConditions)) {
            setStatusConditions(configModules?.statusConditions)
        }

        if (Array.isArray(configModules?.optimizationActivitiesStates)) {

            const filtedStates = configModules?.optimizationActivitiesStates?.filter((state: any) => state?.type?.includes("Requirement"))

            setOptimizationActivitiesStates(filtedStates)
        }

        setReasonsOfPriority(configModules?.priorityReasonOptions || [])

    }, [configModules])


    useEffect(() => {

        const blockers = []

        const types = type.split(',').map((item: string) => item.trim())

        if (types.length === 0) {
            setlistActiveBloquers([]);
            return;
        }

        for (const typeOfAction of types) {
            const typeActivity = typesActivities.find(
                (activity: any) => activity.label === typeOfAction
            );
            const values: any = { ...lastStatusConditions }

            for (const blocker of typeActivity?.deppendOf || []) {
                const statusBlocker = statusConditions.find(
                    (status: any) => status.field === blocker
                )?.warningStatus;

                if (statusBlocker?.includes(values[blocker])) {
                    blockers.push(blocker)
                }
            }
        }

        setlistActiveBloquers(blockers)
    }, [formValues])

    useEffect(() => {

        const enableOptionsFiltered = []

        for (const activity of typesActivities) {
            const exist = currentRequirements.find(
                (requirement: any) => requirement.variableId === activity.id && requirement.status === "pending"
            );
            if (!exist) {
                enableOptionsFiltered.push(activity.label)
            }
        }
        setEnableOptions(enableOptionsFiltered);
    }, [typesActivities])


    const { type, comment, status, priority, priorityReason, priorityExtraReason } = formValues;

    const columns: GridColDef[] = [
        { field: "location", headerName: "Locación", flex: 1 },
        {
            field: "name",
            headerName: "Requerimiento",
            flex: 1,
        },
        { field: "comments", headerName: "Comentario", flex: 1 },
        { field: "status", headerName: "Estado", flex: 1 },
        { field: "priority", headerName: "Prioridad", flex: 1 },
        { field: "priorityReason", headerName: "Razón de Prioridad", flex: 1 },
        { field: "priorityExtraReason", headerName: "Razón de Prioridad Extra", flex: 1, renderCell: (params) => {
            return <span>{params?.row?.priorityReason==="Otra" ? params.value : null}</span>;
        }},
        {
            field: "actions",
            headerName: "",
            width: 100,

            renderCell: (params) => {
                return (
                    <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
                        <IconButton
                            color="error"
                            onClick={() => handleDeleteRequirement(params.row.id)}
                            size="small"
                        >
                            <DeleteIcon />
                        </IconButton>
                        <IconButton
                            size="small"
                            color="primary"
                            onClick={() => handleEditRow(params.row)}
                        >
                            <EditIcon fontSize="medium" />
                        </IconButton>
                    </Grid>
                );
            },
        },
    ];

    const paginationModel = { page: 0, pageSize: 10 };

    const handleClose = () => setOpen(false);

    const handleAddRequirement = () => {

        const blocker = listActiveBloquers?.map((blocker: any, index: number) => {
            const values: any = { ...lastStatusConditions }
            const statusBlocker = statusConditions.find(
                (status: any) => status.field === blocker
            );

            return { [String(statusBlocker?.name)]: values[blocker] }
        })

        const types = type.split(',').map((item: string) => item.trim())

        const otherRequirements = requirements.filter(r => ![...types].includes(r.name))

        const data = []

        for (const typeOfAction of types) {
            const element = typesActivities.find(
                (activity: any) => activity.label === typeOfAction
            );

            const finalPriorityReason = priority==="normal" ? "" : priorityReason;
            const finalPriorityExtraReason = finalPriorityReason==="Otra" ? priorityExtraReason : "";

            data.push({
                id: element?.id,
                location: locationName,
                name: typeOfAction,
                value: "Si",
                type: "Requirement",
                comments: comment,
                blocker,
                status: status,
                priority,
                priorityReason: finalPriorityReason,
                priorityExtraReason: finalPriorityExtraReason,
            })
        }

        // TODO: Uncomment this block if you want to prevent adding requirements when there are blockers
        // if (blocker?.length > 0) {
        //     Swal.fire({
        //         title: "Existen bloqueantes para esta actividad, no puede ser programada continuar.",
        //         text: "",
        //         icon: "error",
        //         confirmButtonColor: "#3085d6",
        //         confirmButtonText: "Entendido",
        //         customClass: {
        //             title: "sweat_alert_title"
        //         }
        //     });
        //     return;
        // }

        setRequeriments([...data, ...otherRequirements]);
        reset();
        setOpen(false);
    };

    const handleDeleteRequirement = (id: string) => {
        const newRequirements = requirements.filter(
            (requirement: any) => requirement.id !== id
        );
        setRequeriments(newRequirements);
    };

    const handleEditRow = (row: any) => {
        setNuewValues({
            type: row.name,
            comment: row.comments,
            status: row.status,
            priority: row.priority,
            priorityReason: row.priorityReason,
            priorityExtraReason: row.priorityExtraReason,
        })
        setOpen(true);
    }

    return (
        <Grid container spacing={0}>
            <Grid size={12}>
                <DataGrid
                    rows={requirements}
                    columns={columns}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[10, 20, 50, 100]}
                    checkboxSelection={false}
                    sx={{
                        border: 0,
                        mt: 2,
                        "& .MuiDataGrid-columnHeader": {
                            backgroundColor: "#316EBC",
                            color: "#fff",
                            fontWeight: "bold",
                        },
                    }}
                    getRowId={(row) => row.id}
                />
            </Grid>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            mb: 2,
                        }}
                    >
                        <IconButton
                            aria-label="delete"
                            onClick={handleClose}
                            sx={{
                                backgroundColor: "#cf1919",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#ff3535",
                                },
                                width: 30,
                                height: 30,
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <Grid sx={{ padding: 1, }}>
                        <InputLabel id="demo-simple-select-label">
                            Tipo de Actividad
                        </InputLabel>
                        <Autocomplete
                            multiple
                            id="size-small-standard-multi"
                            size="small"
                            options={enableOptions}
                            value={type !== "" ? type?.split(',').map((item: string) => (item !== "" && item.trim())) : []}
                            onChange={(event: any, newValue: any) => {
                                setNuewValues({
                                    ...formValues,
                                    type: newValue.join(',')
                                })
                            }}
                            sx={{
                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "4px",
                                padding: "4px 8px",
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="standard"
                                />
                            )}
                        />
                    </Grid>
                    <Grid sx={{ padding: 1 }}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="demo-simple-select-label">
                                Estado
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                label="Estado"
                                id="demo-simple-select"
                                name="status"
                                value={status}
                                onChange={handleInputChange}
                                size="small"
                            >
                                {/* <MenuItem value=""></MenuItem> */}
                                {optimizationActivitiesStates.map((state: any, index) => {
                                    return (
                                        <MenuItem
                                            value={state.id}
                                            key={index}
                                        >
                                            {capitalizeWords(state.name)}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid className="container_location_status" sx={{ paddingTop: 2 }}>
                        {listActiveBloquers?.map((blocker: any, index: number) => {
                            const values: any = { ...lastStatusConditions }
                            const statusBlocker = statusConditions.find(
                                (status: any) => status.field === blocker
                            );
                            return (
                                <Chip
                                    key={index}
                                    className="warningChip"
                                    label={`${statusBlocker?.name} : ${values[blocker]}`}
                                    variant="outlined" />
                            )
                        })}
                    </Grid>

                    <Grid className="priority_section">
                        <InputLabel sx={{
                            paddingLeft: 1,
                        }}>Prioridad</InputLabel>
                        <ButtonGroup
                            variant="outlined"
                            fullWidth
                            aria-label="outlined button group"
                            className="internal_button_group_Section"
                        >
                            {["Normal", "Alta", "Urgente"].map((button, index) => (
                                <Button
                                    key={index}
                                    variant={formValues.priority === button.toLowerCase() ? "contained" : "outlined"}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setNuewValues({
                                            ...formValues,
                                            priority: button.toLowerCase()
                                        })
                                    }}
                                    size="small"
                                >
                                    {button}
                                </Button>
                            ))}
                        </ButtonGroup>
                    </Grid>

                    {priority !== "normal" && (
                        <>
                            <Grid sx={{ mt: 2, pr: 1, pl: 1 }}>
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label">
                                        Razon de Priorizar el Requerimiento
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        label="Razon de Priorizar el Requerimiento"
                                        id="demo-simple-select"
                                        name="priorityReason"
                                        value={priorityReason}
                                        onChange={handleInputChange}
                                        size="small"
                                    >
                                        {/* <MenuItem value=""></MenuItem> */}
                                        {reasonsOfPriority.map((reason: any, index) => {
                                            return (
                                                <MenuItem
                                                    value={reason}
                                                    key={index}
                                                >
                                                    {capitalizeWords(reason)}
                                                </MenuItem>
                                            )
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {priorityReason === "Otra" && (
                                <TextField
                                    fullWidth
                                    size="small"
                                    label="razón de priorización"
                                    sx={{ mt: 2, pr: 1, pl: 1 }}
                                    value={priorityExtraReason}
                                    name="priorityExtraReason"
                                    onChange={handleInputChange}
                                />
                            )}
                        </>
                    )}

                    <TextField
                        fullWidth
                        size="small"
                        label="Comentario"
                        multiline
                        rows={4}
                        sx={{ mt: 2, pr: 1, pl: 1 }}
                        value={comment}
                        name="comment"
                        onChange={handleInputChange}
                    />

                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        size="small"
                        sx={{ mt: 2 }}
                        onClick={handleAddRequirement}
                    >
                        Agregar
                    </Button>
                </Box>
            </Modal>
        </Grid>
    );
};
